export const updateObject = (oldState, newState) => {
	return {
		...oldState,
		...newState,
	};
};

export const toggleItem = (arr, item) => {
	const uniq = Array.from(new Set(arr));
	return (uniq.indexOf(item) > -1) ? uniq.filter(i => i !== item) : [...uniq, item];
};
